export default function accountToast() {
    return {
        queue: [],
        message: null,
        product: null,
        visible: false,
        timer: null,
        dataAttributes: {},

        init() {
            this.$watch('queue.length', (newValue) => {
                if (newValue > 0 && !this.visible) {
                    this.showNextToast();
                }
            });
        },

        handleToast(detail) {
            this.queue.push(detail);
        },

        showNextToast() {
            if (this.queue.length === 0) {
                this.visible = false;
                return;
            }

            const { message, product, dataAttributes } = this.queue.shift();
            this.message = message;
            this.product = product;
            this.dataAttributes = dataAttributes || {};
            this.visible = true;

            // Clear any existing timer
            if (this.timer) {
                clearTimeout(this.timer);
            }

            this.timer = setTimeout(() => {
                this.hideToast();
            }, 2000); // Hide after 2 seconds
        },

        hideToast() {
            this.visible = false;
            // Allow time for fade-out animation before showing the next toast
            setTimeout(() => {
                this.message = null;
                this.product = null;
                this.dataAttributes = {};
                if (this.queue.length > 0) {
                    this.showNextToast();
                }
            }, 500); // Should match animation duration
        },
    };
}